module.exports = __webpack_public_path__ + "img/Bring.5961b468.png";